module.exports = {
  container: {
    width: '100%'
  },
  text: {
    width: '100%',
    display: ''
  },
  play: {
    hover: {
      backgroundColor: 'GhostWhite'
    },
    button: {
      width: '34',
      height: '34',
      cursor: 'pointer',
      // pointerEvents: 'none',
      outline: 'none',
      backgroundColor: 'Gainsboro',
      border: 'solid 1px rgba(255,255,255,1)',
      borderRadius: 6
    }
  },
  stop: {
    hover: {
      backgroundColor: 'GhostWhite'
    },
    button: {
      width: '34',
      height: '34',
      cursor: 'pointer',
      // pointerEvents: 'none',
      outline: 'none',
      backgroundColor: 'Gainsboro',
      border: 'solid 1px rgba(255,255,255,1)',
      borderRadius: 6
    }
  },
  pause: {
    hover: {
      backgroundColor: 'GhostWhite'
    },
    button: {
      width: '34',
      height: '34',
      cursor: 'pointer',
      // pointerEvents: 'none',
      outline: 'none',
      backgroundColor: 'Gainsboro',
      border: 'solid 1px rgba(255,255,255,1)',
      borderRadius: 6
    }
  },
  resume: {
    hover: {
      backgroundColor: 'GhostWhite'
    },
    button: {
      width: '34',
      height: '34',
      cursor: 'pointer',
      // pointerEvents: 'none',
      outline: 'none',
      backgroundColor: 'Gainsboro',
      border: 'solid 1px rgba(255,255,255,1)',
      borderRadius: 6
    }
  }
};
